import {
  CellWrapper,
  DisabledTag
} from '@nile/mangifera/src/Pebbles/TicketContainer';
import React from 'react';
import styled from 'styled-components';
import {
  Active,
  Inactive,
  Prospect
} from '@nile/client_management/src/Pebbles/ClientForm';
import { BackgroundIcon } from '@nile/components';
import envConfig from '@nile/home/src/Config/env';
import { SVGIcon } from '@superops/super-icons';

const colorMap = {
  Prospect: '#D2E3FF',
  Active: '#A7DABA',
  Inactive: '#E8E8E8'
};

const Wrapper = styled.div`
  width: auto;
  height: 40px;
  padding: 4px;
  .ribbon {
    background: ${(props) => colorMap[props.stage] || '#A6C8FF'};
  }
`;

function StageStatusCell(props) {
  const { cell, action } = props;
  const { actions } = cell.column;
  const { value } = cell;
  const data = cell.row.original;
  const stageMap = {
    Prospect: (
      <div className="fx center">
        <SVGIcon name="Prospect" size="sm" />
      </div>
    ),
    Active: (
      <div className="fx center">
        <SVGIcon name="ActiveClient" />
      </div>
    ),
    Inactive: (
      <div className="fx center">
        <SVGIcon name="InactiveClient" />
      </div>
    )
  };
  /* revisit dangerouslySetInnerHTML xss  */
  return value ? (
    <Wrapper stage={data?.stage}>
      <div className="ribbon">
        <div className="ribbon-content flex center fhp text-medium">
          <div className="mr8 w-4 h-4">{stageMap[data?.stage]}</div>
          <div>{data?.stage}</div>
          {data?.status ? (
            <>
              <div className="ml8">
                <div className="splitter"> </div>
              </div>
              <div className="ml8">{data?.status}</div>
            </>
          ) : (
            ''
          )}
        </div>
      </div>
    </Wrapper>
  ) : (
    <DisabledTag>NA</DisabledTag>
  );
}

export default StageStatusCell;
